import React, { useState, useRef, useEffect } from "react";
import SwalUI from "../../../components/ui/swal-ui/swal-ui";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
} from "@mui/material";
import { ChromePicker } from "react-color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { svBusinessTypeUpdate } from "../../../services/setting/businesstype.service";

function FormEditBusinesstypes(props) {
  const { businessTypesEdit, setModalEdit, setRefreshData } = props;
  const [editData, setEditData] = useState(businessTypesEdit);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState({
    typrnmae: false,
  });

  const handleCloseColorPicker = () => {
    setShowColorPicker(false);
  };

  const addValidators = () => {
    let isValid = true;
    let error = {
      ...isError,
      typrnmae: editData.types_name.trim().length < 1,
    };
    setIsError(() => error);

    const hasError = Object.values(error).find((err) => err === true);
    if (hasError) isValid = false;

    if (isValid) {
      const formData = new FormData();
      formData.append("idbusiness", editData.id);
      formData.append("typesname", editData.types_name);
      formData.append("typescolor", editData.box_color);

      /* Display the key/value pairs*/
      for (var pair of formData.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }
      //   return false;
      svBusinessTypeUpdate(formData).then((res) => {
        // console.log(res.response.data.typesname);
        if (res.status === 200) {
          setRefreshData((prev) => prev + 1);
          setModalEdit(false);
          SwalUI({
            status: res.data.status,
            //description: res.data.description
          });
        } else {
          const  [Btypename]  = res.response.data.typesname;
// console.log(Btypename);
          setErrorMessage(Btypename);
          
        }
      });
    }
  };

  return (
    <div>
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            paddingBottom: "1rem",
          }}
          className="defective-nav"
        >
          <div style={{ width: "100%" }}>
            <p
              className=""
              style={{
                fontSize: "1.75rem",
                fontWeight: 500,
                alignItems: "center",
              }}
            >
              เพิ่ม / แก้ไข ประเภทธุรกิจ
            </p>
          </div>
        </div>
        <div className="box-form">
          <div className="first-row">
            <label htmlFor="">ชื่อประเภทธุรกิจ</label>
            <TextField
              id="outlined-basic"
              // label="ประเภทธุรกิจ"
              variant="outlined"
              size="small"
              sx={{ width: "20%" }}
              value={editData.types_name}
              // error={isError.typrnmae}
              error={isError.typrnmae}
              onChange={(e) =>
                setEditData((prevState) => {
                  return { ...prevState, types_name: e.target.value };
                })
              }
              helperText={errorMessage}
              FormHelperTextProps={{
                sx: {
                  color: "red",
                  fontSize:"5px",
                },
              }}
            />
          </div>

          <div className="first-row">
            <label htmlFor="">เลือกสี</label>
            <div>
              <TextField
                id="outlined-basic"
                label={
                  <div
                    style={{
                      borderRadius: "3px",
                      height: "25px",
                      width: "70px",
                      backgroundColor: editData.box_color,
                      border: "1px solid",
                    }}
                  />
                }
                variant="outlined"
                size="small"
                sx={{ width: "20%", paddingBottom: "6px" }}
                value={editData.box_color}
                onFocus={() => setShowColorPicker(true)}
                // onBlur={() => setShowColorPicker(false)} // เมื่อ TextField ไม่ได้ focus ให้ซ่อน ChromePicker
              />
              {showColorPicker && (
                <div
                  style={{ display: "flex", alignItems: "start", gap: "4px" }}
                >
                  <ChromePicker
                    color={editData.box_color}
                    onChange={(color) =>
                      setEditData((prevState) => {
                        return { ...prevState, box_color: color.hex };
                      })
                    }
                  />
                  <FontAwesomeIcon
                    onClick={handleCloseColorPicker}
                    icon={faCircleXmark}
                    style={{ color: "#f00000", cursor: "pointer" }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "scale(1.1)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="box-btn">
          {/* <Button
          variant="contained"
          size="small"
          style={{
            fontSize: "16px",
            background: "#FF2C2C",
            color: "white",
            height: "39px",
            width: "100px",
          }}
          onClick={handleReset}
          className="button-Delete"
        >
          ลบข้อมูล
        </Button> */}

          <Button
            variant="contained"
            size="small"
            style={{
              fontSize: "16px",
              background: "#707070",
              color: "white",
              height: "39px",
              width: "100px",
            }}
            component="a"
            onClick={() => {
              setModalEdit(false);
            }}
            className="button-h"
          >
            ยกเลิก
          </Button>
          <Button
            variant="contained"
            size="small"
            style={{
              fontSize: "16px",
              background: "#6C5DD3",
              color: "white",
              height: "39px",
              width: "100px",
            }}
            component="a"
            onClick={addValidators}
            className="button-h"
          >
            บันทึก
          </Button>
        </div>
      </>
    </div>
  );
}

export default FormEditBusinesstypes;
